import type {
  EngagementUpdateReason,
  NormalizedEngagementConfig,
} from '../../contracts/engagement';

export type EngagementEmissionInput = {
  readonly reason: EngagementUpdateReason;
  readonly score: number;
  readonly previousScore: number;
};

/**
 * Decide se um ENGAGEMENT_UPDATE deve ser emitido.
 *
 * - `initial`: emissão inicial documentada (uma vez, controlada pelo engine).
 * - `manual_evaluation`: emissão explícita solicitada (sempre emite).
 * - `interval` / `signal_threshold`: só emite com `emitOnChange` e delta
 *   suficiente (`abs(score - previousScore) >= minScoreDelta`).
 */
export class EngagementEmissionPolicy {
  private readonly config: NormalizedEngagementConfig;

  constructor(config: NormalizedEngagementConfig) {
    this.config = config;
  }

  shouldEmit(input: EngagementEmissionInput): boolean {
    if (input.reason === 'initial' || input.reason === 'manual_evaluation') {
      return true;
    }

    if (!this.config.emitOnChange) {
      return false;
    }

    const delta = Math.abs(input.score - input.previousScore);
    return delta >= this.config.minScoreDelta;
  }
}
